import { localStorage } from 'shared/helper/storage';
var SUBMIT_SURVEY_RESPONDED_KEY = 'curieSubmitSurveyResponded';
export var hasRespondedToSubmitSurvey = function hasRespondedToSubmitSurvey() {
  return !!localStorage.get(SUBMIT_SURVEY_RESPONDED_KEY);
};
export var markSubmitSurveyResponded = function markSubmitSurveyResponded() {
  return localStorage.set(SUBMIT_SURVEY_RESPONDED_KEY, true);
};